// import Editor from "../components/editor";
import { useEffect, useState } from "react";
import Editor from "../components/editor-with-use-quill";
import { BackIcon, PreviewIcon } from "../icons";
import { generateCode } from "../utils/common";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";

export default function WriteArticlePage() {
  const [searchParams] = useSearchParams();
  const [loading, setIsLoading] = useState<boolean>(false);
  const [title, setTitle] = useState("");
  const [editorContent, setEditorContent] = useState("");
  const [code, setCode] = useState("");
  const key = searchParams.get("edit");

  const addRow = async (e: any) => {
    e.preventDefault();
    const newRow = {
      code,
      title: title,
      content: editorContent,
      date: new Date().toISOString(),
    };

    if (key) {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/${key}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(newRow),
          }
        );

        if (!response.ok) {
          toast.error("Failed to add blog");
        }

        toast.success("Opération reussie");
      } catch (error) {
        toast.error("Erreur de chargement");
      } finally {
        setIsLoading(false);
      }
    } else {
      try {
        setIsLoading(true);
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newRow),
        });

        if (!response.ok) {
          toast.error("Failed to add blog");
        }
        setTitle("");
        fetchNumer();
        setEditorContent(" ");
        toast.success("Opération reussie");
      } catch (error) {
        toast.error("Erreur de chargement");
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchBlog();
  }, []);

  const fetchNumer = () => {
    const newCode = generateCode(6);
    setCode(newCode);
  };

  const fetchBlog = async () => {
    if (key) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/${key}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          toast.error("Erreur de chargement");
        }
        const result = await response.json();
        setCode(result.code);
        setTitle(result.title);
        setEditorContent(result.content);
      } catch (error) {
        toast.error("Erreur de chargement");
      }
    } else {
      fetchNumer();
    }
  };

  return (
    <div className="py-4 md:py-6">
      <form onSubmit={addRow}>
        <main className="pb-4 md:pb-6 flex flex-col px-4 md:px-6 lg:px-8 xl:px-16 h-full w-full md:max-w-[100rem] 2xl:max-w-[1060px] md:mx-auto gap-6 font-dmsans">
          <div className="flex flex-row items-center justify-between gap-4 w-full">
            <div className="flex flex-row items-center gap-2">
              <a href="/blog-list">
                <BackIcon href="/blog-list" className="h-4 w-4" />
              </a>
              <div className="flex flex-col">
                <span className="text-base text-primary-7 font-medium">
                  BLog
                </span>
                <span className="text-[10px] text-primary-7/80 font-medium">
                  N° {code}
                </span>
              </div>
            </div>
            <div className="flex flex-row gap-4">
              {/* <a
                href="/write-blog"
                className="flex items-center gap-2 bg-primary-5 hover:bg-primary-5/80 font-normal text-[10px] md:text-xs text-white h-8 px-2 rounded-md"
              >
                <span>Preview</span>
                <PreviewIcon className="h-4 w-4" />
              </a> */}
              <button
                className="bg-primary-100 flex items-center gap-2 hover:bg-primary-100/80 font-normal text-[10px] md:text-sm text-white h-8 px-6 rounded-md"
                type="submit"
                disabled={loading}
              >
                {loading && (
                  <div
                    className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                    role="status"
                  >
                    <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                      Loading...
                    </span>
                  </div>
                )}
                Sauvegarder le blog
              </button>
            </div>
          </div>
          <div className="flex flex-col w-full gap-2">
            <label className="text-xs md:text-base">Titre</label>
            <input
              type="text"
              className="h-12 text-base md:w-full font-normal placeholder:text-xs md:placeholder:text-base placeholder:font-normal border rounded-lg px-4 focus:outline-none"
              required={true}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <Editor
            handleButtonClick={(editorContent) =>
              setEditorContent(editorContent)
            }
            initialContent={editorContent}
          />
        </main>
      </form>
    </div>
  );
}
